import type { PayPalCheckout, PayPalTokenizePayload } from 'braintree-web';
import type { OnApproveBraintreeData } from '@paypal/react-paypal-js';

export enum ItemKind {
    CREDIT = 'credit',
    DEBIT = 'debit',
}
export interface LineItem {
    name: string;
    unitAmount: number;
    quantity: number;
    kind: ItemKind;
}

export const DiscountItemName = 'Discount';

/** PayPal shipping payload used by express checkout (paypal-js no longer exports ShippingInfo). */
export interface ShippingInfo {
    phone_number?: { national_number?: string };
    options?: unknown[];
    name?: { full_name?: string };
    address?: {
        address_line_1?: string;
        address_line_2?: string;
        postal_code?: string;
        country_code?: string;
        admin_area_1?: string;
        admin_area_2?: string;
    };
}

export type ShippingInfoWithOptions = ShippingInfo & { options: unknown[] };

/** Options for Braintree PayPalCheckout.updatePayment (missing from @types/braintree-web). */
export interface PayPalCheckoutUpdatePaymentOptions {
    paymentId: string;
    amount: string | number;
    currency: string;
    shippingOptions?: {
        id: string | number;
        label: string;
        selected: boolean;
        type: string;
        amount: {
            currency: string;
            value: string;
        };
    }[];
    lineItems?: LineItem[];
}

/**
 * Braintree PayPalCheckout instance used by express checkout.
 * Extends the published type with updatePayment and PayPal JS SDK approve-data tokenization.
 */
export type PayPalCheckoutInstance = PayPalCheckout & {
    updatePayment(options: PayPalCheckoutUpdatePaymentOptions): Promise<unknown>;
    tokenizePayment(tokenizeOptions: OnApproveBraintreeData): Promise<PayPalTokenizePayload>;
};
